import React from 'react';

const Header = () => {
  return (
    <header>
      <div className="domain-banner">
        <h2>beastasi.com is FOR SALE</h2>
      </div>
    </header>
  );
};

export default Header; 